<div class="content-wrapper-inner relative">
  <div class="page-content">
    <div class="header-wrapper" #headerWrapper>
      <h2 class="mb-20">Coverage requests</h2>
      <div class="instruction-container mb-20">
        <div class="important-note">
          <div>Please note:</div>
          <div>- only currently unavailable networks can be requested</div>
          <div>- if you would like to request a network that is not on the list, please contact our support</div>
        </div>
      </div>
      <div class="table-topbar mb-20">
        <div class="search-panel">
          <div class="search-control">
            <span class="icon-search"></span>
            <input type="search" class="form-control table-search" [formControl]="searchControl" />
          </div>
          <div *ngIf="isAdmin" class="client-filter filter-wrapper">
            <div class="filter-tab">
              <a
                class="dropdown-toggle"
                role="button"
                tabindex="0"
                [dropdown]="clientsContent"
                dropdownPlacement="bottom-start"
                [title]="clientFilterTitle">
                <i class="icon-user"></i> Users <span *ngIf="mainaccounts.length">({{ mainaccounts.length }})</span>
              </a>
              <ng-template #clientsContent>
                <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
                  <app-users-select
                    [multiple]="true"
                    [roles]="['mainaccount']"
                    [restoreSavedSearch]="false"
                    (selectUser)="onSelectMainaccount($event)"
                    (unSelectUser)="onUnselectMainaccount($event)"
                    (clear)="onClearMainaccount()"></app-users-select>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="table-action-holder">
          <div class="create">
            <button *ngIf="isAdmin" type="button" (click)="onClickMap()" [disabled]="mapLoading" class="btn btn-primary py-10 px-15">
              <i class="fas" [ngClass]="mapLoading ? 'fa-spinner spin' : 'fa-th-large'"></i>
              {{ mapLoading ? 'Loading countries...' : 'Countries' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper" #tableWrapper [attr.aria-busy]="loading">
      <div [hidden]="!loading" class="spinner table-loading" role="status" aria-label="Loading coverage">
        <div class="sk-spinner sk-spinner-pulse medium"></div>
      </div>
      <app-coverage-table [networks]="networks"></app-coverage-table>
    </div>
  </div>
</div>
<ng-template #coverageMapModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Countries</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-coverage-map [networks]="mapNetworks"></app-coverage-map>
  </div>
</ng-template>
